<div id="forms" class="page-layout simple fullwidth" fxLayout="column">
    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->
    <!-- CENTER -->
    <div class="center">
        <!-- CONTENT HEADER -->
        <div class="header primary p-24" fxLayout="row" fxLayoutAlign="start center">
            <button mat-icon-button class="mr-16" [routerLink]="'/home'">
                <mat-icon>arrow_back</mat-icon>
            </button>
            <h2 class="m-0">{{'PROFILE.BTNBACK' | translate}}</h2>
            <h1 class="m-0" style="padding-left: 40%!important; font-weight:bolder;">{{'PROFILE.MYPROFILLE' | translate}}</h1>
        </div>
        <!-- / CONTENT HEADER -->
        <!-- CONTENT CARD -->
        <div class="content-card" class="center " fxLayout="row wrap">
            <!-- CONTENT -->
            <div style="margin: 20px;" fxFlex="100" fxLayout="row" fxLayoutAlign="start stretch">

                <mat-sidenav-container fxFlex="100">
                    <mat-sidenav #sidenav mode="side" [(opened)]="show">
                        <div fxLayout="row" fxLayoutAlign="center stretch" class="">
                            <div class="p-20" fxFlex="100" fxLayout="column" fxLayoutAlign="start stretch">
                                <div class="" fxLayout="row" fxLayoutAlign="space-between center">
                                    <h2>{{'PROFILE.MENU_TITLE' | translate}}</h2>
                                    <button mat-icon-button (click)="sidenav.toggle()">
                                      <mat-icon>close</mat-icon>
                                    </button>
                                </div>
                                <mat-divider></mat-divider>
                                <div class="" fxLayout="row" fxLayoutAlign="start stretch">
                                    <ul id="menutree">
                                        <li class="collapse" style="padding-top: 5px;" (click)="obtenerMenu(1)">
                                            <input type="checkbox" id="m1" checked *ngIf="m1_check" />
                                            <input type="checkbox" id="m1" *ngIf="!m1_check" />
                                            <label for="m1" id="m1_check">
                                            {{'PROFILE.MENU.OPC1' | translate}}
                                        </label>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </mat-sidenav>

                    <mat-sidenav-content>
                        <!--Visualización de acciones -->
                        <div fxLayout="row" class="example-sidenav-content" style="padding-top: 0px; " fxLayoutAlign="center stretch" fxFlex="100">

                            <div class="course-step-content p-20" fxFlex="100">
                                <div class="" fxLayout="column" fxLayoutAlign="start center">
                                    <h1>{{'PROFILE.TITLE' | translate}}</h1>
                                    <button mat-mini-fab color="accent" *ngIf="!show" (click)="sidenav.toggle()" class="botonInfo" matTooltipPosition="right">
                                          <mat-icon>info</mat-icon>
                                    </button><br><br>
                                </div>

                                <ng-container *ngIf="seccionProfile">
                                    <form [formGroup]="myForm">
                                        <!--<div fxLayout="row">
                                            <div fxLayout="row" fxLayoutAlign="start start" fxFlex="20">
                                                <h2>{{'PROFILE.NAME' | translate}}</h2>
                                            </div>
                                            <div fxLayout="row" fxLayoutAlign="start start" style="padding-left: 15px;" fxFlex="70">
                                                <mat-form-field appearance="outline" style="width: 100%;" class="formulario">
                                                    <mat-label></mat-label>
                                                    <input matInput type="text" formControlName="name">
                                                    <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                                                    <mat-error>{{'PROFILE.ERROR.ERROR01' | translate}}</mat-error>
                                                </mat-form-field>
                                            </div>
                                        </div>-->
                                        <div fxLayout="row">
                                            <div fxLayout="row" fxLayoutAlign="start start" fxFlex="20">
                                                <h2>{{'PROFILE.EMAIL' | translate}}</h2>
                                            </div>
                                            <div fxLayout="row" fxLayoutAlign="start start" style="padding-left: 15px;" fxFlex="70">
                                                <mat-form-field appearance="outline" style="width: 100%;" class="formulario">
                                                    <mat-label></mat-label>
                                                    <input matInput type="text" formControlName="email" (blur)="checkData()" (keydown.enter)="checkData()">
                                                    <mat-icon matSuffix class="secondary-text">email</mat-icon>
                                                    <mat-error>{{'PROFILE.ERROR.ERROR01' | translate}}</mat-error>
                                                </mat-form-field>
                                            </div>
                                            <div fxLayout="row" fxLayoutAlign="start center" style="padding-left: 15px;" fxFlex="30">
                                                <button mat-raised-button (click)="enviarVerificacion()" [disabled]="bloquearBtnCodigo"> {{'PROFILE.SENDCODE' | translate}} </button>
                                            </div>
                                        </div>
                                    </form>


                                    <ng-container *ngIf="sendCode">
                                        <div fxLayout="row">
                                            <div fxLayout="row" fxLayoutAlign="start start" fxFlex="20">
                                                <h2>{{'PROFILE.CODE' | translate}}</h2>
                                            </div>
                                            <div fxLayout="row" fxLayoutAlign="start start" style="padding-left: 15px;" fxFlex="50">
                                                <mat-form-field appearance="outline" style="width: 100%;">
                                                    <mat-label></mat-label>
                                                    <input matInput type="text" [(ngModel)]="codeverify">
                                                    <mat-icon matSuffix class="secondary-text">security</mat-icon>
                                                    <mat-error>{{'PROFILE.ERROR.ERROR01' | translate}}</mat-error>
                                                </mat-form-field>

                                            </div>
                                            <div fxLayout="row" fxLayoutAlign="start center" style="padding-left: 15px;" fxFlex="30">
                                                <button mat-raised-button (click)="checkCode()">{{'PROFILE.CHECKCODE' | translate}}</button>
                                            </div>
                                        </div><br>
                                    </ng-container>

                                    <ng-container *ngIf="check_code">
                                        <form [formGroup]="passwordForm" autocomplete="off">
                                            <div fxLayout="row">
                                                <div fxLayout="row" fxLayoutAlign="start start" fxFlex="20">
                                                    <h2>{{'PROFILE.NEWPASS' | translate}}</h2>
                                                </div>
                                                <div fxLayout="row" fxLayoutAlign="start start" style="padding-left: 15px;" fxFlex="50">
                                                    <!-- <mat-form-field appearance="outline" style="width: 100%;">
                                                        <mat-label></mat-label>
                                                        <input matInput [type]="hide ? 'password' : 'text'" formControlName="password1" #idPassword autocomplete="off" (blur)="checkfirts()" (keydown.enter)="checkfirts()" #idPassword autocomplete="off">
                                                        <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
                                                        <mat-error>{{'PROFILE.ERROR.ERROR01' | translate}}</mat-error>
                                                    </mat-form-field> -->
                                                </div>
                                            </div>
                                            <div fxLayout="row">
                                                <div fxLayout="row" fxLayoutAlign="start start" fxFlex="20">
                                                    <h2>{{'PROFILE.REPASS' | translate}}</h2>
                                                </div>
                                                <div fxLayout="row" fxLayoutAlign="start start" style="padding-left: 15px;" fxFlex="50" *ngIf="showSecond_pass">
                                                    <!-- <mat-form-field appearance="outline" style="width: 100%;">
                                                        <mat-label></mat-label>
                                                        <input matInput [type]="hide2 ? 'password' : 'text'" formControlName="password2" #idPassword2 autocomplete="off" (blur)="checkPassword()" (keydown.enter)="checkPassword()" #idPassword autocomplete="off">
                                                        <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
                                                        <mat-error>{{'PROFILE.ERROR.ERROR01' | translate}}</mat-error>
                                                    </mat-form-field> -->
                                                </div>
                                            </div>
                                            <div fxLayout="row" fxLayoutAlign="center center">
                                                <button mat-raised-button color="warn" [disabled]="btnChangePassword" (click)="actualizarDatos()" placehorder="">{{'PROFILE.CHANGE' | translate}}</button>
                                            </div>
                                        </form>
                                    </ng-container>
                                    <br><br><br><br>
                                </ng-container>
                            </div>
                        </div>
                    </mat-sidenav-content>
                </mat-sidenav-container>
            </div>
            <!-- / CONTENT -->
        </div>
    </div>
</div>
